import type { InputHTMLAttributes } from "react";
import { TextInput } from "@/components/ui/field";

/** Campo de valor em reais (texto livre: "1.234,56"); a conversão para centavos fica com parseMoneyInput. */
export function MoneyInput(props: InputHTMLAttributes<HTMLInputElement> & { label: string; hint?: string }) {
  return <TextInput inputMode="decimal" autoComplete="off" placeholder="0,00" {...props} />;
}
